/* @flow */
import { observer } from 'mobx-react';
import * as React from 'react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import TogglePassword from './TogglePassword';

import { PasswordModel } from 'models/AccountModels';

import styles from 'common-scss/formstyles.module.scss';

type TypeWithPasswordModel = {| model: PasswordModel, autoComplete: string |};

//DoublePassword.js
function DoublePasswordP({
  t,
  model,
  autoComplete,
}: TypeWithPasswordModel & TranslatorProps): React.Element<*> {
  let isError: boolean = false;
  let errorMessage: string = null;

  if (model.passwordNonBlank) {
    isError = !model.passwordsMatch || !model.passwordNonBlank || !model.passwordLengthOK;

    errorMessage =
      (model.passwordLengthOK
        ? null
        : t('general:accounts.messages.passwords_min_length', model)) ||
      (model.passwordsMatch ? null : t('general:accounts.messages.passwords_must_match')) ||
      (model.passwordNonBlank ? null : t('general:accounts.messages.passwords_not_blank'));
  }

  return (
    <div className={styles['double-password']}>
      <FormControl error={isError}>
        <TogglePassword
          autoComplete={autoComplete}
          model={model}
          error={isError}
          required={true}
          prop="password1"
          floatingLabelText={t('general:password')}
          hintText={t('general:accounts.messages.required_characters')}
        />
        <TogglePassword
          autoComplete={autoComplete}
          model={model}
          error={isError}
          required={true}
          prop="password2"
          floatingLabelText={t('general:accounts.confirm_password')}
          hintText={t('general:accounts.messages.retype_password')}
        />
        <FormHelperText className={styles['validation-error']}>{errorMessage}</FormHelperText>
      </FormControl>
    </div>
  );
}

type TypeComponentPasswordModel = Class<React.Component<TypeWithPasswordModel>>;

export const DoublePassword: TypeComponentPasswordModel = translate()(observer(DoublePasswordP));
